import React from "react";
import styles from "./FilterButton.module.css"; // Corrected import

function FilterButton() {
  return (
    <button className={styles["filter-button"]}> {/* Ensuring valid class name */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="16"
        viewBox="0 0 24 24"
        width="16"
        fill="#555"
        className={styles["filter-icon"]}
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M10 18h4v-2h-4v2zm-7-7h18v-2H3v2zm3-7v2h12V4H6z" />
      </svg>
      Filter
    </button>
  );
}

export default FilterButton;
